import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import VueCustomElement from "vue-custom-element";
import "document-register-element/build/document-register-element";
import VueTelInput from "vue-tel-input";
import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);
Vue.use(VueCustomElement);
Vue.use(i18n);
Vue.use(VueTelInput);

App.i18n = i18n;

App.store = store;
App.router = router;

Vue.customElement("widget-view", App,{
  
});

Vue.config.productionTip = false;
